import { Box, styled } from '@mui/material';

export const WorkBoxTitle = styled(Box)(({ marginBottom }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: 14,
  marginTop: 16,
  marginBottom: marginBottom ?? 0,
}));

export const WeekDaysBox = styled(Box)(({ theme, selected }) => ({
  minWidth: 35,
  minHeight: 35,
  borderRadius: '50%',
  marginRight: 20,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  fontSize: 12,
  fontWeight: 600,
  color: selected ? theme.palette.common.white : theme.palette.grey[500],
  backgroundColor: selected ? theme.palette.primary.main : theme.palette.grey[200],
}));

export const WeekDaysBoxContainer = styled(Box, {
  shouldForwardProp: (props) => !['error'].includes(props),
})(({ theme, error }) => ({
  padding: 12,
  border: `1px solid ${!error ? theme.palette.grey[500] : '#ff1744'}`,
  borderRadius: 16,
  marginTop: 16,
  width: 'fit-content',
}));

export const Next = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  padding: '24px 80px',
  borderTop: `1px solid ${theme.palette.grey[300]}`,
  backgroundColor: theme.palette.common.white,
  display: 'flex',
  justifyContent: 'flex-end',
  zIndex: 2,
}));
export const Main = styled(Box)(({ isUpdate }) => ({
  width: '-webkit-fill-available',
  overflowY: 'auto',
}));
